import { PendingEverifyItem } from '@/features/pending_everify/application/domain/entities/PendingEverifyItem';
import { IEVerifyCaseSummaryRepository } from '../ports/outbound/IEVerifyCaseSummaryRepository';

export class FetchEVerifyCaseSummaryUseCase {
  constructor(private readonly repository: IEVerifyCaseSummaryRepository) {}

  async execute(i9FormId: string): Promise<PendingEverifyItem[]> {
    return this.repository.fetchEVerifyCaseSummary(i9FormId);
  }
}
